import { Champignons, ChampignonsCreateInput, ChampignonsListResponse, ChampignonsResponse, ChampignonsSelectInput, ChampignonsSelectOption, ChampignonsUpdateInput } from "@repo/types";
import { AxiosInstance } from 'axios';

import { axiosInstance } from '../axios-instance';
import { API_CONFIG, ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class ChampignonService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.CHAMPIGNONS.BASE, axios);
  }

  async getChampignons(filters: ChampignonsSelectInput): Promise<ChampignonsListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Champignons>({ page, limit, ...rest });
  }

  async getChampignonById(id: number): Promise<ChampignonsResponse> {
    return this.get<ChampignonsResponse>(`/${id}`);
  }

  async createChampignon(data: ChampignonsCreateInput): Promise<ChampignonsResponse> {
    return this.post<ChampignonsResponse, ChampignonsCreateInput>('', data);
  }

  async updateChampignon(id: number, data: ChampignonsUpdateInput): Promise<ChampignonsResponse> {
    return this.put<ChampignonsResponse, ChampignonsUpdateInput>(`/${id}`, data);
  }

  async deleteChampignon(id: number): Promise<ChampignonsResponse> {
    return this.delete<ChampignonsResponse>(`/${id}`);
  }

  async restoreChampignon(id: number): Promise<ChampignonsResponse> {
    return this.put<ChampignonsResponse>(`/${id}/restore`);
  }

  async getChampignonOptions(): Promise<ChampignonsSelectOption[]> {
    return this.get<ChampignonsSelectOption[]>('/select');
  }

  async getChampignonCategories(): Promise<string[]> {
    return this.get<string[]>('/categories');
  }

  async uploadChampignonImage(
    id: number,
    imageFile: File,
    onProgress?: (percent: number) => void,
  ): Promise<ChampignonsResponse> {
    const formData = new FormData();
    formData.append('image', imageFile);
    const { data } = await this.axios.post<ChampignonsResponse>(
      `${ENDPOINTS.CHAMPIGNONS.UPDATE_IMAGE(id.toString())}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: API_CONFIG.uploadTimeout,
        onUploadProgress: (event) => {
          if (!event.total) {
            return;
          }
          onProgress?.(Math.round((event.loaded * 100) / event.total));
        },
      }
    );

    return data;
  }
}
